<template>
  <section v-if="pageState === 'ready'" class="vh-100 position-relative">
    <LanguageSwitcher class="position-absolute top-20 right-0 me-0 border-0"></LanguageSwitcher>
    <div class="container-fluid">
      <div class="row">
        <div
          class="col-sm-5 d-sm-flex vh-100 flex-column m-auto h-initial-sm login-left cursor-pointer remove-share"
          style="background-color: #0068b0; padding-top: 12rem"
          @click="goHome"
        >
          <img
            src="../assets/login-logo.svg"
            alt="Login image"
            style="width: 18rem; padding-left: 8.14rem"
            class="login-logo login-section"
          />
          <p
            style="margin-top: 2.6rem; padding-left: 8.14rem"
            class="text-white fw-normal mb-9 fs-28 login-section login-desc"
          >
            {{ $t('login.introduction') }}
          </p>

          <img
            src="../assets/login-left.svg"
            alt="Login"
            style="width: 25.875rem; height: 25.875rem; margin: 0 auto"
            class="login-desc-img"
          />
        </div>

        <div class="col-sm-7 text-black w-100-sm">
          <div class="d-flex align-items-center h-custom-2 px-5 ms-xl-4 pt-5 pt-xl-0">
            <!-- 表单区域 -->
            <form style="width: 48rem" class="m-auto" @submit.prevent="handleReset">
              <h1 class="fw-bold mb-0 fs-42" style="color: #131313">
                <span>{{ $t('login.resetPassword') }}</span>
              </h1>
              <span
                @click.prevent="goLogin"
                class="d-inline-block register-tip fw-bold"
                style="
                  margin-top: 0.89rem;
                  color: #0068b0;
                  font-size: 1.33rem;
                  margin-bottom: 3rem;
                  cursor: pointer;
                "
              >
                {{ $t('login.back') }}
              </span>

              <div class="position-relative w-100 mb-3" style="margin-top: 1.5rem">
                <label class="form-label d-flex align-items-center" style="gap: 0.89rem" for="email">
                  <img src="../assets/email.svg" alt="email" style="width: 1.25rem" />
                  <span style="color: #3f4855; font-size: 0.875rem">{{ $t('login.email') }}</span>
                </label>
                <input
                  type="email"
                  id="email"
                  v-model="email"
                  disabled
                  class="form-control form-control-lg w-100 text-1d2939"
                  style="background-color: #ECEFF2; border: 1px solid #c9defc"
                />
              </div>

              <div class="position-relative w-100 mb-3">
                <label class="form-label d-flex align-items-center" style="gap: 0.89rem" for="password">
                  <img src="../assets/vpn-key.svg" alt="email" style="width: 1.25rem" />
                  <span style="color: #3f4855; font-size: 0.875rem">{{ $t('login.password') }}</span>
                </label>
                <input
                  type="password"
                  id="password"
                  v-model="password"
                  class="form-control form-control-lg w-100 text-1d2939 password-input"
                  style="background-color: #f8fbff; border: 1px solid #c9defc"
                />
                <div
                  style="width: 1.5rem; height: 1.5rem; right: 1rem; top: 2.55rem"
                  class="position-absolute eye-icon d-none cursor-pointer"
                ></div>
              </div>

              <div class="position-relative w-100 mb-3">
                <label
                  class="form-label d-flex align-items-center"
                  style="gap: 0.89rem"
                  for="confirmed-password"
                >
                  <img src="../assets/vpn-key.svg" alt="email" style="width: 1.25rem" />
                  <span style="color: #3f4855; font-size: 0.875rem">
                    {{ $t('login.passwordConfirm') }}
                  </span>
                </label>
                <input
                  type="password"
                  id="confirmed-password"
                  v-model="confirmPassword"
                  class="form-control form-control-lg w-100 text-1d2939 password-input"
                  style="background-color: #f8fbff; border: 1px solid #c9defc"
                />
                <div
                  style="width: 1.5rem; height: 1.5rem; right: 1rem; top: 2.55rem"
                  class="position-absolute eye-icon d-none cursor-pointer"
                ></div>
              </div>

              <div class="pt-1">
                <button
                  @click.prevent="handleReset"
                  class="btn btn-lg btn-block fw-bold text-white btn-reset-password"
                  style="background-color: #0068b0; font-size: 0.875rem"
                  type="button"
                  :disabled="loading"
                >
                  {{ $t('login.resetPassword') }}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
 <div  v-else-if="pageState === 'invalid' || pageState === 'notfound'">
    <nav  class="navbar navbar-expand-lg navbar-light" style="box-shadow: none">
        <div class="container-fluid pe-0">
          <a class="navbar-brand mt-2 mt-lg-0" href="/" style="margin-left: 0.5rem">
            <img
              src="../assets/dashboard-logo.svg"
              width="168"
              height="32"
              alt="SCANAT Logo"
              loading="lazy"
            />
          </a>
          <LanguageSwitcher class="border-0 me-0"/>
        </div>
   </nav>
  <section
   
    class="position-relative min-vh-100 d-flex align-items-center justify-content-center"
    style="background-image: url('../assets/landing/bg.svg'); background-size: cover"
  >
    <div class="text-center">
      <img
        v-if="pageState === 'invalid'"
        src="../assets/icons/img_link_valid_pw.svg"
        alt="Link Invalid"
        style="width: 200px; height: 175px"
      />
      <img
        v-else
        src="../assets/icons/img_link_no.svg"
        alt="Link Not Found"
        style="width: 200px; height: 175px"
      />
      <div
        v-if="pageState === 'invalid'"
        style="font-size: 1.25rem; font-weight: 700; color: #1c2124; margin-top: 2rem"
      >
        {{ $t('login.invalid.info') }}
      </div>
      <div v-if="pageState === 'invalid'" style="margin-top: 0.75rem; color: #6b7280">
        {{ $t('login.invalid.tip') }}
      </div>

      <div
        v-if="pageState === 'notfound'"
        style="font-size: 1.25rem; font-weight: 700; color: #1c2124; margin-top: 2rem"
      >
        {{ $t('login.noExist.info') }}
      </div>
      <div v-if="pageState === 'notfound'" style="margin-top: 0.75rem; color: #6b7280">
        {{ $t('login.noExist.tip') }}
      </div>
    </div>
  </section>
 </div>
</template>

<script setup>
import { nextTick, onMounted, ref, watchEffect } from 'vue'
import i18n from 'src/lang/index.js'
import LanguageSwitcher from 'src/admin/components/common/LanguageSwitcher.vue'
import { isEmail, request } from 'scripts/utils.js'
import Toast from 'scripts/toast.js'

const email = ref('')
const password = ref('')
const confirmPassword = ref('')
const loading = ref(false)
const pageState = ref('loading') // loading | ready | invalid | notfound
const resetToken = ref('')
const toast = new Toast()
const eyeIconEventHandlers = new Map()
const $t = i18n.global.t

const isValidPassword = (pwd) => /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9%_+\-.]{10,50}$/.test(pwd || '')

const goLogin = () => {
  window.location.href = '/login.html'
}

const goHome = () => {
  window.location.href = '/'
}

const updateTitle = state => {
  if (state === 'ready') {
    document.title = `${$t('login.resetPassword')} Scanat`
  } else if (state === 'invalid') {
    document.title = `${$t('title.link.useless')}`
  } else if (state === 'notfound') {
    document.title = `${$t('title.link.notExist')}`
  }
}

watchEffect(() => {
  updateTitle(pageState.value)
})

const setupPasswordEyeIcon = () => {
  const passwordEl = document.getElementById('password')
  const confirmPasswordEl = document.getElementById('confirmed-password')
  const eyeIcons = document.querySelectorAll('.eye-icon')

  eyeIcons.forEach((eyeIcon, index) => {
    if (eyeIconEventHandlers.has(eyeIcon)) {
      const handlers = eyeIconEventHandlers.get(eyeIcon)
      eyeIcon.removeEventListener('mouseover', handlers.mouseover)
      eyeIcon.removeEventListener('mouseout', handlers.mouseout)
      eyeIconEventHandlers.delete(eyeIcon)
    }

    const targetInput = index === 0 ? passwordEl : confirmPasswordEl
    if (!targetInput) return

    const mouseoverHandler = () => {
      if (targetInput.type === 'password') targetInput.type = 'text'
    }
    const mouseoutHandler = () => {
      if (targetInput.type === 'text') targetInput.type = 'password'
    }

    eyeIcon.addEventListener('mouseover', mouseoverHandler)
    eyeIcon.addEventListener('mouseout', mouseoutHandler)
    eyeIconEventHandlers.set(eyeIcon, { mouseover: mouseoverHandler, mouseout: mouseoutHandler })
  })
}

const handleReset = async () => {
  if (!email.value || !password.value || !confirmPassword.value) {
    toast.toast('danger', $t('login.noEmpty'))
    return
  }
  if (!isValidPassword(password.value) || !isValidPassword(confirmPassword.value)) {
    toast.toast('danger', $t('login.passwordTip'))
    return
  }
  if (!isEmail(email.value)) {
    toast.toast('danger', $t('login.emailError'))
    return
  }
  loading.value = true
  const res = await request(
    'auth/portal/reset_password',
    {
      email: email.value,
      password: password.value,
      confirmPassword: confirmPassword.value,
      key: resetToken.value
    },
    false
  )
  loading.value = false

  if (res?.code === 200) {
    toast.toast('success', $t('login.resetPasswordSuccess'), false, {
      callback: () => {
        window.location.href = '/login.html'
      }
    })
  } else if (res?.code === 412) {
    pageState.value = 'invalid'
    updateTitle('invalid')
  } else if (res?.code === 413) {
    pageState.value = 'notfound'
    updateTitle('notfound')
  }
}

const initByToken = async () => {
  const params = new URLSearchParams(window.location.search)
  const token = params.get('token') || ''
  resetToken.value = token
  if (!token) {
    pageState.value = 'notfound'
    updateTitle('notfound')
    return
  }

  try {
    const res = await request('auth/checkResetPasswordKey', { key: token }, false)
    if (res?.code === 200) {
      email.value = res?.data || ''
      pageState.value = 'ready'
      updateTitle('ready')
      await nextTick()
      setupPasswordEyeIcon()
    } else if (res?.code === 412) {
      pageState.value = 'invalid'
      updateTitle('invalid')
    } else if (res?.code === 413) {
      pageState.value = 'notfound'
      updateTitle('notfound')
    } else {
      pageState.value = 'invalid'
      updateTitle('invalid')
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e)
  }
}

onMounted(() => {
  initByToken()
})
</script>


